import NepalCases from './NepalCases';

export default NepalCases;
